import { enumKeyByValue } from '@app/shared/helpers';
import { CouponType, InterestPaymentType } from '@app/shared/models/contracts/enums/shared-enums';
import { translationKeys } from '@locale/setupI18n';
import { t } from 'i18next';

const translatedCoupon: { [key: string]: translationKeys } = {
  [enumKeyByValue(CouponType, CouponType.NoCoupon)]: '_NoCoupon',
  [enumKeyByValue(CouponType, CouponType.CompoundInterest)]: '_CompoundInterest',
  [enumKeyByValue(CouponType, CouponType.SimpleInterest)]: '_SimpleInterest',
};

const translatedCouponAbbrv: { [key: string]: translationKeys } = {
  [enumKeyByValue(CouponType, CouponType.NoCoupon)]: '_NoCouponAbbrv',
  [enumKeyByValue(CouponType, CouponType.CompoundInterest)]: '_CompoundInterestAbbrv',
  [enumKeyByValue(CouponType, CouponType.SimpleInterest)]: '_SimpleInterestAbbrv',
};

export const mapCouponTypeInterestToTranslation = (
  text: keyof typeof CouponType
): translationKeys | undefined => {
  return text ? (t(translatedCoupon[text]) as translationKeys) : undefined;
};

export const mapCouponTypeInterestToTranslationWithHover = (
  text: keyof typeof CouponType
): { short: string; full: string } => {
  const short = t(translatedCouponAbbrv[text]) as translationKeys;
  const full = t(translatedCoupon[text]) as translationKeys;
  return { short, full };
};

const translatedInterest: { [key: string]: translationKeys } = {
  [enumKeyByValue(InterestPaymentType, InterestPaymentType.CashPay)]: '_CashPay',
  [enumKeyByValue(InterestPaymentType, InterestPaymentType.PaymentInKind)]: '_PaymentInKind',
  [enumKeyByValue(InterestPaymentType, InterestPaymentType.PaymentInKindAndCashPay)]:
    '_PaymentInKindAndCashPay',
};

export const mapInterestToTranslation = (text: string): translationKeys => {
  return t(translatedInterest[text]);
};
